import { TagColors, TagVariants } from "./types";

export const lightColorScheme: Record<
  TagColors,
  {
    labelColorClassName: string;
  }
> = {
  [TagColors.Neutral]: {
    labelColorClassName: "bg-neutral border border-neutral-dark",
  },
  [TagColors.PrimaryLight]: {
    labelColorClassName: "bg-primary-light border border-neutral-dark text-dark",
  },
  [TagColors.Primary]: {
    labelColorClassName: "bg-primary text-light border border-primary",
  },
  [TagColors.Glass]: {
    labelColorClassName: "bg-glass text-dark font-semibold border border-transparent",
  },
  [TagColors.Wood]: {
    labelColorClassName: "bg-wood text-dark font-semibold border border-transparent",
  },
  [TagColors.Stone]: {
    labelColorClassName: "bg-stone text-dark font-semibold border border-transparent",
  },
  [TagColors.Materia]: {
    labelColorClassName: "bg-materia text-dark font-semibold border border-transparent",
  },
  [TagColors.Metal]: {
    labelColorClassName: "bg-metal text-dark font-semibold border border-transparent",
  },
  [TagColors.Transparent]: {
    labelColorClassName: "bg-transparent text-dark font-semibold border border-transparent",
  },
};

export const primaryColorScheme: Record<
  TagColors,
  {
    labelColorClassName: string;
  }
> = {
  [TagColors.Neutral]: {
    labelColorClassName: "bg-primary text-light border border-light border-opacity-50",
  },
  [TagColors.PrimaryLight]: {
    labelColorClassName: "bg-primary-light bg-opacity-50 border border-primary-light text-light",
  },
  [TagColors.Primary]: {
    labelColorClassName: "bg-light border border-primary text-primary",
  },
  [TagColors.Transparent]: {
    labelColorClassName: "bg-transparent text-light font-semibold border border-transparent",
  },
  [TagColors.Glass]: lightColorScheme[TagColors.Glass],
  [TagColors.Wood]: lightColorScheme[TagColors.Wood],
  [TagColors.Stone]: lightColorScheme[TagColors.Stone],
  [TagColors.Materia]: lightColorScheme[TagColors.Materia],
  [TagColors.Metal]: lightColorScheme[TagColors.Metal],
};

export const colorScheme: Record<
  TagVariants,
  Record<
    TagColors,
    {
      labelColorClassName: string;
    }
  >
> = {
  [TagVariants.Primary]: primaryColorScheme,
  [TagVariants.Light]: lightColorScheme,
};
